import { type RestaurantLocation } from "@dashboard/types";
import { type ReduxState } from "@dashboard/types/reduxState";

import { RestaurantSelectedAction } from "./restaurantReducer";

export type LocationReducerAction =
  | { type: "SET_LOCATION"; payload: RestaurantLocation }
  | { type: "DELETE_LOCATION"; payload: string } // payload is locationId
  | { type: "FETCHED_LOCATIONS"; payload: RestaurantLocation[] }
  | RestaurantSelectedAction;

export const locationReducer: (
  state: ReduxState["location"] | undefined,
  action: LocationReducerAction
) => ReduxState["location"] = (
  state: ReduxState["location"] = {
    intialLocationsLoading: true,
    locations: [],
  },
  action: LocationReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_SELECTED":
      return {
        ...state,
        intialLocationsLoading: true,
      };

    case "SET_LOCATION":
      // if the location is already present, we update it
      // else we add it to the beginning.
      const locationIndex = state.locations.findIndex(
        (location) => location.id === action.payload.id
      );

      if (locationIndex !== -1) {
        // update
        return {
          ...state,
          locations: [
            ...state.locations.slice(0, locationIndex),
            action.payload,
            ...state.locations.slice(locationIndex + 1),
          ],
        };
      } else {
        // add
        return {
          ...state,
          // locations are sorted by createdAt ascending
          locations: [...state.locations, action.payload],
        };
      }

    case "DELETE_LOCATION":
      return {
        ...state,
        locations: state.locations.filter(
          (location) => location.id !== action.payload
        ),
      };

    case "FETCHED_LOCATIONS":
      return {
        ...state,
        intialLocationsLoading: false,
        locations: action.payload, // ordering is done in the action
      };
    default:
      return state;
  }
};
